<script>
  import { Tabs, TabsItem, Breadcrumb, BreadcrumbItem, Icon, Loader } from "@gl/design-system"
  import { AppsRepository } from "../../repositories/index"
  import { Route, Router, Link, navigate } from "svelte-routing"
  import { Layout } from "../../components/index"
  import { onMount, getContext } from "svelte"
  import { _ } from "../../stores/index"
  import AppAssignments from "./AppAssignments.svelte"
  import AppPolicies from "./AppPolicies.svelte"
  const { isAuthorized } = getContext("isAuthorized")

  export let id

  let app = {}
  let loading = true

  let selectedTab = "contracts"

  const setSelectedTabFromPathname = () => {
    const path = decodeURIComponent(window.location.pathname)
    if (path.includes("policies")) {
      selectedTab = "policies"
    } else {
      selectedTab = "contracts"
    }
  }

  async function fetchApp() {
    try {
      loading = true

      app = await AppsRepository.getApplication(id)
    } finally {
      loading = false
    }
  }

  onMount(() => {
    fetchApp()
    setSelectedTabFromPathname()
  })
</script>

<Layout selected="globalApps">
  {#if !loading}
    <Breadcrumb>
      <BreadcrumbItem
        on:click={() => navigate("/access-manager/admin/apps")}
        on:keypress={(e) => {
          if (e.key === "Enter") navigate("/access-manager/admin/apps")
        }}
      >
        {$_("common.apps")}
      </BreadcrumbItem>
      <BreadcrumbItem current>
        {app.data.name}
      </BreadcrumbItem>
    </Breadcrumb>

    <h3 class="gl-title level-3">
      {$_("common.app")}: {app.data.name}
    </h3>

    <Tabs class="mt-5">
      <TabsItem selected={selectedTab === "contracts"}>
        <Link to={`admin/apps/${id}/contracts`} on:click={() => (selectedTab = "contracts")}>
          {$_("common.contracts")}
        </Link>
      </TabsItem>

      {#if $isAuthorized("policy_read")}
        <TabsItem selected={selectedTab === "policies"}>
          <Link to={`admin/apps/${id}/policies`} on:click={() => (selectedTab = "policies")}>
            {$_("common.policies")}
          </Link>
        </TabsItem>
      {/if}
    </Tabs>

    <Router>
      <Route path="/contracts">
        <AppAssignments {id} />
      </Route>
      <Route path="/policies">
        <AppPolicies {app} {id} />
      </Route>
    </Router>
  {:else}
    <Loader />
  {/if}
</Layout>
